import { CallEntitiesOverview, CallEntity, CallEntityTemplateItem } from './call-entities.service'

export type CallEntityReadiness = 'NO_CALL_MINUTES' | 'NO_INTERVALS' | 'NO_ENTITY_SPECIFIC_ITEMS' | 'READY'

/** Whether an item's minutes are its own entity's, because it or an item above it is minuted per entity. */
export function inheritsEntityScope(item: CallEntityTemplateItem, items: CallEntityTemplateItem[]): boolean {
  const parent = item.parentId === null ? null : (items.find((candidate) => candidate.templateItemId === item.parentId) ?? null)
  return parent !== null && (parent.isEntitySpecific || inheritsEntityScope(parent, items))
}

/** Mirrors the checks the server makes before it will generate an entity's minutes, in the order it makes them. */
export function resolveCallEntityReadiness(overview: CallEntitiesOverview, entity: CallEntity): CallEntityReadiness {
  if (!overview.hasCallMinutes) {
    return 'NO_CALL_MINUTES'
  }
  if (entity.intervals.length === 0) {
    return 'NO_INTERVALS'
  }
  const appliesToEntity = overview.templateItems.some(
    (item) =>
      item.isEntitySpecific &&
      !inheritsEntityScope(item, overview.templateItems) &&
      (item.applicableCallEntityIds.length === 0 || item.applicableCallEntityIds.includes(entity.id))
  )
  return appliesToEntity ? 'READY' : 'NO_ENTITY_SPECIFIC_ITEMS'
}
